import ConsentLinks from "../../components/Consents/ConsentLinks.jsx";

export function RegistrationFooter() {
  return (
    <footer className="card-footer no-border">
      <div className="footer-text">
        <ConsentLinks />
      </div>
    </footer>
  );
} 